/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MappaPastoScuola } from './mappaPastoScuola';

export interface ConfigurazioneComuneView { 
    numeroGiorniOPastiResiduiPromemoriaPagamento?: number;
    assistenzaEmail?: string;
    mappaPastiScuola?: Array<MappaPastoScuola>;
    numeroGiorniOPastiResiduiSospensioneServizio?: number;
    orarioMassimoPerAnnullamentoPasto?: string;
    statoRicaricaManuale?: ConfigurazioneComuneView.StatoRicaricaManualeEnum;
    tipoPagamento?: ConfigurazioneComuneView.TipoPagamentoEnum;
}
export namespace ConfigurazioneComuneView {
    export type StatoRicaricaManualeEnum = 'ATTIVA' | 'NON_ATTIVA';
    export const StatoRicaricaManualeEnum = {
        ATTIVA: 'ATTIVA' as StatoRicaricaManualeEnum,
        NONATTIVA: 'NON_ATTIVA' as StatoRicaricaManualeEnum
    };
    export type TipoPagamentoEnum = 'NON_GESTITO' | 'MANUALE' | 'PAGO_PA_RICARICHE' | 'PAGO_PA_RENDICONTAZIONE_E_RICARICHE' | 'PAGO_PA_RENDICONTAZIONE';
    export const TipoPagamentoEnum = {
        NONGESTITO: 'NON_GESTITO' as TipoPagamentoEnum,
        MANUALE: 'MANUALE' as TipoPagamentoEnum,
        PAGOPARICARICHE: 'PAGO_PA_RICARICHE' as TipoPagamentoEnum,
        PAGOPARENDICONTAZIONEERICARICHE: 'PAGO_PA_RENDICONTAZIONE_E_RICARICHE' as TipoPagamentoEnum,
        PAGOPARENDICONTAZIONE: 'PAGO_PA_RENDICONTAZIONE' as TipoPagamentoEnum
    };
}